import script from "./GoogleReviewsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleReviewsCard.vue?vue&type=script&setup=true&lang=js"

import "./GoogleReviewsCard.vue?vue&type=style&index=0&id=04857d81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04857d81"]])

export default __exports__